import { Component, Input } from '@angular/core';
import { IColumns } from '../../../../shared/interfaces/custom-table';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'tr[customHeader]',
  standalone: true,
  imports: [
    CommonModule,
    TableModule
  ],
  template: `
    <th *ngFor="let col of columns" [id]="col.id" [pSortableColumn]="col.sort ? col.field : undefined"
        [ngClass]="col.class" [ngStyle]="col.style"
        class="text-center" [style.width]="col.width ? col.width : null">
    {{col.header}}
    <p-sortIcon *ngIf="col.sort" [field]="col.field"></p-sortIcon>
    <p-columnFilter *ngIf="col.columnFilter" [field]="col.field" display="menu"></p-columnFilter>
  </th>
  `
})
export class CustomTableHeader {
  @Input() columns !: IColumns[];

}
